module.exports = require('./lib/main')



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/index.js
// module id = 369
// module chunks = 0